var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SearchBar',{ref:"MinimalSearchBar",attrs:{"active":true,"minimalSearch":true},on:{"user-is-searchin":_vm.userIsTypingSomething}})}
var staticRenderFns = []

export { render, staticRenderFns }